/* eslint-disable */
// Diesel & Dust Group — Terms & Conditions content
// Structured for reuse across the website AND for embedding into
// job-card / approval / paperwork forms in later phases.

export const TERMS_META = {
  effectiveDate: "May 2026",
  brand: "Diesel & Dust Group",
  tagline:
    "Mobile Automotive Solutions | Windscreens | Mechanical Services | Fleet Support",
};

export const TERMS_INTRO =
  "Welcome to Diesel & Dust Group. By accessing this website, requesting quotations, booking services, approving repairs, or making use of any services provided by Diesel & Dust Group, the client agrees to the Terms & Conditions set out below.";

export const TERMS_SERVICES = [
  "Windscreen replacement and repairs",
  "Automotive glass services",
  "Mobile fitment services",
  "Mobile mechanic call-outs",
  "Vehicle diagnostics",
  "Minor vehicle servicing",
  "General vehicle repairs",
  "Fleet maintenance support",
  "Parts sourcing and fitment",
];

// Each section: { id, title, items: [string|{type:'p'|'list', text|items}] }
export const TERMS_SECTIONS = [
  {
    id: "quotations",
    title: "1. Quotations & Estimates",
    items: [
      "1.1 All quotations are valid for 7 (seven) days unless otherwise stated in writing.",
      "1.2 Quotations are based on information supplied by the client and may change upon physical inspection of the vehicle.",
      "1.3 Additional faults, hidden damages, or unforeseen mechanical issues discovered during repairs may result in revised quotations and additional charges.",
      "1.4 Quotations do not guarantee parts availability or supplier stock.",
    ],
  },
  {
    id: "authorisation",
    title: "2. Authorisation of Work",
    items: [
      "2.1 Any verbal, written, electronic, WhatsApp, email, digital, or signed approval from the client authorises Diesel & Dust Group to proceed with the requested work.",
      "2.2 The client confirms that they are authorised to approve repairs and services on the vehicle concerned.",
      "2.3 Additional work identified during inspection or repair may require further approval before continuation.",
    ],
  },
  {
    id: "mobile-call-out",
    title: "3. Mobile Call-Out Services",
    items: [
      "3.1 Mobile services are performed at the client's requested location at the client's own risk.",
      "3.2 The client must ensure that the vehicle is parked in a safe, accessible, and suitable working environment.",
      "3.3 Diesel & Dust Group reserves the right to refuse work where conditions are deemed unsafe or unsuitable.",
      "3.4 Delays caused by weather conditions, traffic, restricted access, load shedding, supplier delays, or unsafe conditions shall not constitute breach of service.",
    ],
  },
  {
    id: "glass-services",
    title: "4. Windscreen & Automotive Glass Services",
    items: [
      "4.1 All glass installed may consist of OEM, OEE, or approved aftermarket products unless otherwise specified.",
      "4.2 Windscreen adhesive requires sufficient curing time to bond correctly to the vehicle body structure.",
      "4.3 Clients are advised not to drive the vehicle for a minimum period of:",
      {
        type: "list",
        items: [
          "120 minutes after standard windscreen replacement; and",
          "up to 240 minutes where the vehicle is equipped with airbags or where specifically advised by the technician.",
        ],
      },
      "4.4 Failure to observe the recommended safe drive-away period may result in:",
      {
        type: "list",
        items: [
          "wind noise,",
          "water leaks,",
          "improper bonding,",
          "or compromised vehicle safety.",
        ],
      },
      "4.5 Diesel & Dust Group shall not be liable for damages, leaks, or safety issues resulting from failure to comply with post-fitment instructions.",
      "4.6 Existing rust, body damage, structural weaknesses, previous poor workmanship, cracked trims, or hidden defects may affect fitment results and are outside the Company's control.",
      "4.7 Temporary retention or safety tape applied during fitment should remain in place for at least 24 hours before removal.",
    ],
  },
  {
    id: "mechanical-repairs",
    title: "5. Mechanical Repairs & Vehicle Servicing",
    items: [
      "5.1 Diagnostic assessments are based on visible, testable, and accessible conditions at the time of inspection.",
      "5.2 Diesel & Dust Group cannot guarantee that additional underlying or unrelated faults do not exist.",
      "5.3 Repairs performed are limited to work specifically authorised by the client.",
      "5.4 The Company shall not be liable for failures caused by pre-existing defects, neglected maintenance, prior repairs, worn components, or unrelated mechanical failures.",
      "5.5 The client acknowledges that older vehicles and high-mileage vehicles may present unforeseen mechanical complications during or after repairs.",
    ],
  },
  {
    id: "parts-suppliers",
    title: "6. Parts, Suppliers & Delays",
    items: [
      "6.1 Parts availability is dependent on third-party suppliers and distributors.",
      "6.2 Estimated delivery times are not guaranteed.",
      "6.3 Diesel & Dust Group shall not be liable for delays caused by suppliers, manufacturers, importers, couriers, or circumstances beyond reasonable control.",
      "6.4 Special-order parts may require upfront payment and may not be refundable once ordered.",
    ],
  },
  {
    id: "inspection",
    title: "7. Vehicle Inspection & Pre-Existing Damage",
    items: [
      "7.1 Clients acknowledge that pre-existing scratches, dents, paint defects, rust, cracked trims, electrical issues, worn components, or prior damages may already exist before work commences.",
      "7.2 Diesel & Dust Group may photograph vehicles before, during, and after repairs for quality control, record keeping, insurance, and liability protection purposes.",
      "7.3 Signed inspection reports, digital approvals, or technician records shall serve as confirmation of the vehicle's condition at the time of service.",
    ],
  },
  {
    id: "personal-belongings",
    title: "8. Personal Belongings",
    items: [
      "8.1 Clients are responsible for removing all personal belongings and valuables from the vehicle prior to any repairs or fitment.",
      "8.2 Diesel & Dust Group shall not be liable for loss, theft, or damage to personal belongings left inside the vehicle.",
    ],
  },
  {
    id: "insurance",
    title: "9. Insurance Claims",
    items: [
      "9.1 The client remains responsible for ensuring that any insurance claim is properly submitted and authorised with their insurer.",
      "9.2 Diesel & Dust Group does not guarantee claim approval by any insurance company.",
      "9.3 Approval, processing, or payment delays by insurers shall not release the client from responsibility for payment of outstanding amounts.",
      "9.4 Any excess amounts, rejected claims, short payments, or non-payments remain the responsibility of the client.",
    ],
  },
  {
    id: "payments",
    title: "10. Payments",
    items: [
      "10.1 Payment terms may vary depending on the nature of the service provided.",
      "10.2 Diesel & Dust Group may require deposits or upfront payments before commencement of work.",
      "10.3 Ownership of supplied parts and materials shall remain with Diesel & Dust Group until payment has been received in full.",
      "10.4 Accounts not settled within the agreed payment period may be handed over for debt recovery or legal collection.",
      "10.5 The client shall remain liable for:",
      {
        type: "list",
        items: [
          "outstanding amounts due,",
          "reasonable legal costs,",
          "collection commission,",
          "tracing fees,",
          "and attorney costs where legally recoverable in terms of South African law.",
        ],
      },
    ],
  },
  {
    id: "warranty",
    title: "11. Warranty",
    items: [
      "11.1 Warranty applies only to workmanship performed directly by Diesel & Dust Group.",
      "11.2 Warranty excludes:",
      {
        type: "list",
        items: [
          "accidents,",
          "stone damage,",
          "misuse,",
          "negligence,",
          "third-party repairs,",
          "manufacturer defects,",
          "wear and tear,",
          "and failures unrelated to the specific work performed.",
        ],
      },
      "11.3 Warranty claims must be reported immediately upon discovery.",
      "11.4 Warranty assessments shall be subject to inspection by Diesel & Dust Group.",
    ],
  },
  {
    id: "liability",
    title: "12. Limitation of Liability",
    items: [
      "12.1 Diesel & Dust Group shall not be liable for:",
      {
        type: "list",
        items: [
          "indirect losses,",
          "consequential damages,",
          "vehicle downtime,",
          "missed appointments,",
          "business interruption,",
          "loss of income,",
          "towing costs,",
          "accommodation costs,",
          "or delays beyond reasonable control.",
        ],
      },
      "12.2 Services are provided subject to operational, environmental, supplier, and vehicle-condition limitations.",
      "12.3 Nothing in these Terms & Conditions limits any rights afforded to consumers under applicable South African law.",
    ],
  },
  {
    id: "cancellations",
    title: "13. Cancellations",
    items: [
      "13.1 Bookings cancelled after parts have been ordered may be subject to cancellation or restocking fees.",
      "13.2 Call-out fees may apply once technicians have been dispatched to the client's location.",
    ],
  },
  {
    id: "website-use",
    title: "14. Website Use",
    items: [
      "14.1 Information provided on this website is for general informational purposes only.",
      "14.2 Diesel & Dust Group reserves the right to modify pricing, services, products, and website content without prior notice.",
      "14.3 Unauthorised use of website content, branding, logos, or materials is prohibited.",
    ],
  },
  {
    id: "popia",
    title: "15. POPIA & Privacy",
    items: [
      "15.1 Client information is processed in accordance with applicable South African privacy legislation, including the Protection of Personal Information Act (POPIA).",
      "15.2 Information supplied by clients may be used for:",
      {
        type: "list",
        items: [
          "quotations,",
          "bookings,",
          "invoicing,",
          "warranties,",
          "service communication,",
          "and operational administration purposes.",
        ],
      },
      "15.3 Diesel & Dust Group shall take reasonable steps to protect client information.",
    ],
  },
  {
    id: "governing-law",
    title: "16. Governing Law",
    items: [
      "These Terms & Conditions shall be governed by and interpreted in accordance with the laws of the Republic of South Africa.",
    ],
  },
  {
    id: "acceptance",
    title: "17. Acceptance",
    items: [
      "By requesting services, accepting quotations, signing documentation, approving repairs, booking appointments, or using this website, the client acknowledges that they have read, understood, and accepted these Terms & Conditions.",
    ],
  },
];

// Convenience: short clauses for embedding in forms (paperwork phase)
export const TERMS_FORM_SNIPPETS = {
  quoteRequest:
    "By submitting this request, you confirm the details above are accurate and you accept the Diesel & Dust Group Terms & Conditions. Quotations are valid for 7 days and subject to physical inspection of the vehicle (clauses 1.1–1.4).",
  workApproval:
    "I authorise Diesel & Dust Group to proceed with the work described above (clause 2.1). I confirm I am authorised to approve repairs on this vehicle (clause 2.2) and acknowledge that additional work identified during inspection may require further approval (clause 2.3).",
  windscreenSafeDriveAway:
    "I acknowledge the safe drive-away period of 120 minutes (standard) or up to 240 minutes (airbag-equipped) and the 24-hour retention-tape guidance (clauses 4.3, 4.4, 4.7). I accept that failure to comply releases Diesel & Dust Group from liability (clause 4.5).",
  preInspection:
    "I acknowledge that pre-existing damage, rust, electrical issues, or worn components may exist on the vehicle (clauses 4.6, 7.1) and confirm that the photographs and inspection record taken serve as the agreed condition of the vehicle at the time of service (clause 7.3).",
  belongings:
    "I confirm that I have removed all personal belongings and valuables from the vehicle. Diesel & Dust Group is not liable for items left inside (clauses 8.1–8.2).",
  insurance:
    "I remain responsible for submitting and obtaining authorisation for any insurance claim. Diesel & Dust Group does not guarantee claim approval, and any excess, rejection or short-payment remains my responsibility (clauses 9.1–9.4).",
  payment:
    "I accept the payment terms presented and acknowledge that ownership of parts remains with Diesel & Dust Group until payment is received in full (clauses 10.1–10.5).",
};
